import { type ReactNode } from 'react';
import useScrollReveal from '@/hooks/useScrollReveal';

interface RevealWrapperProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

export default function RevealWrapper({ children, className = '', delay = 0 }: RevealWrapperProps) {
  const { ref, visible } = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}